import FormFieldController from "confinus_ui/forms/form_field_controller";

export default class CheckboxController extends FormFieldController {
  public set checked(state: boolean) {
    this.inputTarget!.checked = state;
    // Clear indeterminate when explicitly setting checked state
    this.inputTarget!.indeterminate = false;
  }

  public get checked() {
    return this.inputTarget!.checked;
  }

  public set indeterminate(state: boolean) {
    this.inputTarget!.indeterminate = state;
  }

  public get indeterminate() {
    return this.inputTarget!.indeterminate;
  }
}
